import {FC} from 'react'
import {PopoverText} from '../../../../../components'
import dateformat from 'src/utils/dateformat'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import swal from 'sweetalert'

interface RowDataProps {
  items: any
  rowNumber: number
  reloadTable: () => void
}

export const RowData: FC<RowDataProps> = (props) => {
  const {items, rowNumber} = props
  const {t} = useTranslation()

  const handleCancel = (id: String) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    })
      .then((willDelete: Boolean) => {
        if (willDelete) {
          axios
            .put(`${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2}/log/queue/cancel/${id}`,null, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'X-Credentials': localStorage.getItem('credential'),
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((response) => {
              swal({
                title: `${t('Proses Sedang Dibatalkan')}`,
                icon: 'success',
              })
                .then(() => {
                  props.reloadTable()
                })
            })
            .catch((error) => {
              swal({
                title: `${t('Gagal Membatalkan Proses')}`,
                icon: 'error',
              })
            })
        }
      })
  }

  return (
    <>
      {items.map((item: any, index: number) => (
        <tr key={item.id}>
          <td>{index + 1 + rowNumber}</td>
          <td>{item?.activities}</td>
          <td>{item?.username}</td>
          <td>
            {item.status == 1 && (
              <span className='badge badge-light-warning'>
                <i className='fa me-2 text-warning fa-spin fa-spinner'></i> {t(item.status_text)}
              </span>
            )}
            {item.status == 2 && (
              <span className='badge badge-light-success'>
                <i className='fa me-2 text-success fa-check'></i> {t(item.status_text)}
              </span>
            )}
            {item.status == 3 && (
              <span className='badge badge-light-danger'>
                <i className='fa me-2 text-danger fa-times'></i> {t(item.status_text)}
              </span>
            )}
            {item.status == 4 && (
              <span className='badge badge-light-danger'>
                <i className='fa me-2 text-danger fa-times'></i> {t(item.status_text)}
              </span>
            )}
          </td>
          <td>
            { 
            item.status == 1&& item.processing && item.data ?
            <>
              <div className="progress">
                <div className="progress-bar bg-primary progress-bar-striped" role="progressbar" style={{width: (item.processing / item.data * 100) + "%"}} aria-valuenow={item.processing} aria-valuemin={0} aria-valuemax={item.data}>
                </div>
              </div> <span className='text-primary'>{ item.processing } / { item.data }</span>
            </>
            : <PopoverText
            content={item?.message ? item?.message : '-'}
            index={index}
            trigger='click'
            className='desc-slicee'
          /> }
          </td>
          <td>{dateformat(item?.created_at, {showtime: true})}</td>
          <td>{dateformat(item?.updated_at, {showtime: true})}</td>
          <td>
            { item.status == 1 && <>
              <button
                className='btn btn-icon btn-light-danger btn-sm me-1'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title='Cancel'
                onClick={() => handleCancel(item?.id)}
              >
                <i className='fas fa-times'></i>
              </button>
            </> }
          </td>
        </tr>
      ))}
    </>
  )
}
